<template>
    <b-container fluid style="padding-left: 100px; padding-right: 100px; height: 100%; margin: 20px;">
        <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
            <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
        </parallax>

        <div>
            <h1 style="color: white;">{{ $t('common.registration') }}</h1>
            <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
        </div>

        <validation-observer ref="observer" v-slot="{ invalid }">
            <b-form @submit.prevent="onSubmit" id="registrationForm">
                <b-card>
                    <h3>{{ $t('registration.legal-owners-label') }}</h3>
                    <b-form-group>
                        <input
                            type="checkbox"
                            @change="isLegalOwnerChange($event)"
                            v-model="representative.legalOwner"
                        >{{ $t('registration.legal-owner') }}
                    </b-form-group>
                </b-card>
                <div v-for="(owner, index) in owners" v-bind:key="index">
                    <b-card>
                        <b-form-group cols="11" :label="$t('registration.first-name')">
                            <validation-provider rules="required"
                                                 v-slot="{ errors }">
                                <b-form-input v-model="owners[index].firstName" :disabled="owners[index].disabled"/>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group cols="11" :label="$t('registration.last-name')">
                            <validation-provider rules="required"
                                                 v-slot="{ errors }">
                                <b-form-input v-model="owners[index].lastName" :disabled="owners[index].disabled"/>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>
                      <b-form-group cols="11" :label="$t('registration.tax-number')">
                        <validation-provider rules="required"
                                             v-slot="{ errors }">
                          <b-form-input v-model="owners[index].representativeTaxId" :disabled="owners[index].disabled"/>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-form-group>

                        <b-form-group :label="$t('registration.address')">
                            <validation-provider rules="required"
                                                 v-slot="{ errors }">
                                <b-input-group>
                                    <b-form-input v-model="owners[index].address" :disabled="owners[index].disabled"/>
                                </b-input-group>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('registration.zip')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <b-input-group>
                                    <b-form-input v-model="owners[index].zip" :disabled="owners[index].disabled"/>
                                </b-input-group>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('registration.city')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <b-input-group>
                                    <b-form-input v-model="owners[index].city" :disabled="owners[index].disabled"/>
                                </b-input-group>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('registration.temporary-address')">
                            <validation-provider v-slot="{ errors }">
                                <b-input-group>
                                    <b-form-input v-model="owners[index].addressTemporary" :disabled="owners[index].disabled"/>
                                </b-input-group>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('registration.birth-date')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <el-date-picker
                                    v-model="owners[index].birthDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="dateOptions"
                                    :disabled="owners[index].disabled">
                                </el-date-picker>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group :label="$t('registration.citizenship')">
                            <el-select
                                class="select-primary"
                                style="width: 50%"
                                size="small"
                                v-model="owners[index].citizenship"
                                :disabled="owners[index].disabled">
                                <el-option
                                    v-for="option in countryList"
                                    class="select-primary"
                                    :value="option.id"
                                    :label="option.name"
                                    :key="option.id">
                                </el-option>
                            </el-select>
                        </b-form-group>

                        <b-form-group :label="$t('registration.birth-country')" >
                            <el-select
                                class="select-primary"
                                style="width: 50%"
                                size="small"
                                v-model="owners[index].countryOfBirth"
                                :disabled="owners[index].disabled"
                            >
                                <el-option
                                    v-for="option in countryList"
                                    class="select-primary"
                                    :value="option.id"
                                    :label="option.name"
                                    :key="option.id">
                                </el-option>
                            </el-select>
                        </b-form-group>

                        <b-form-group :label="$t('registration.ownership-percentage')">
                            <validation-provider rules="required"
                                                 v-slot="{ errors }">
                                <b-input-group>
                                    <b-form-input v-model="owners[index].ownershipPercentage"/>
                                </b-input-group>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group>
                            <input
                                type="checkbox"
                                v-model="owners[index].pio"
                            >{{ $t('registration.pio') }}
                        </b-form-group>

                        <button @click="removeAdditionalOwner(index)"
                                class="btn btn-icon btn-wd btn-danger">{{ $t('registration.remove-legal-owner') }}
                        </button>
                    </b-card>
                </div>
                <b-card>
                    <b-card-footer>
                        <button type="button" @click="addAdditionalOwner" class="btn btn-fill btn-info btn-wd">
                            {{ $t('registration.add-legal-owner') }}
                        </button>
                    </b-card-footer>
                </b-card>

            </b-form>

            <b-card>
                <b-card-footer>
                    <b-button class="btn btn-info" name="submitButton" id="registerButton" :disabled="invalid"
                              type="button" @click="onSubmit">
                        {{ $t('registration.submit') }}
                    </b-button>
                </b-card-footer>
            </b-card>
        </validation-observer>
    </b-container>
</template>

<script>
import Parallax from 'vue-parallaxy'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import i18n from "../i18n";
import {DatePicker, Option, Select} from 'element-ui';
import {countries} from '@/data/countries';
import swal from "sweetalert2";

extend('required', {
    ...required,
    message: (_, values) => i18n.t('common.required', values)
});

export default {
    name: "LegalOwnerInput",
    components: {
        Parallax,
        ValidationProvider,
        ValidationObserver,
        [DatePicker.name]: DatePicker,
        [Option.name]: Option,
        [Select.name]: Select
        // UploadImages
    },
    data() {
        return {
            owners: [{
                legalOwner: true,
                ownershipPercentage: null,
                firstName: null,
                lastName: null,
                citizenship: 'SI',
                countryOfBirth: 'SI',
                representativeTaxId: null,
                birthDate: null,
                address: null,
                zip: null,
                city: null,
                addressTemporary: null,
                pio: false,
                disabled: false
            }],
            legalOwnerIndex: null,
            dateOptions: {
                useCurrent: true,
                showClose: true,
                locale: 'sl',
                disabledDate: (time) => {
                    return time > new Date();
                }
            },
            countryList: countries
        }
    },
    computed: {
        representative() {
            return this.$store.getters.getMerchant;
        },
        registrationInfo() {
            return this.$store.getters.getRegistrationInfo;
        },
    },
    methods: {
        onSubmit() {
            if(this.owners.length === 0) {
                this.showAlert(this.$t('registration.one_mandatory_owner'));
                return;
            }

            let query = {
                'representative': this.representative,
                'legalOwners': this.owners
            }

            this.$store.dispatch('addLegalOwners', query)
                .then(() => {
                    this.$router.push('/home/confirmRegistration');
                })
                .catch(error => {
                    this.$store.commit('setError', error);
                    // TODO FIXME XXX handle different AUTH CHECK error codes!
                })
                .finally(() => {
                });

        },
        addAdditionalOwner() {
            let checkEmptyLines = this.owners.filter(line => (
                line.firstName === null ||
                line.lastName === null ||
                line.representativeTaxId === null ||
                line.address === null ||
                line.zip === null ||
                line.city === null ||
                line.birthDate === null ||
                line.citizenship === null ||
                line.countryOfBirth === null ||
                line.ownershipPercentage === null)
            );
            if (checkEmptyLines.length >= 1 && this.owners.length > 0) {
                this.showAlert(this.$t('registration.owners_empty_fields'));
                return;
            }
            if (this.owners.length > 2) {
                this.showAlert(this.$t('registration.max_owners_limit'));
                return;
            }
            this.addEmptyOwner();
        },
        addEmptyOwner() {
            this.owners.push(
                {
                    legalOwner: true,
                    ownershipPercentage: null,
                    firstName: null,
                    lastName: null,
                    citizenship: 'SI',
                    countryOfBirth: 'SI',
                    representativeTaxId: null,
                    birthDate: null,
                    address: null,
                    zip: null,
                    city: null,
                    addressTemporary: null,
                    pio: false,
                    disabled: false
                }
            )
        },
        removeAdditionalOwner(lineId) {
            this.owners.splice(lineId, 1);
            if (lineId === this.legalOwnerIndex) {
                this.representative.legalOwner = false;
            }
        },
        removeAllOwners() {
            this.owners.splice(0);
        },
        isLegalOwnerChange(event) {
            if (event.target.checked === true) {

                if (this.owners.length > 2) {
                    this.showAlert(this.$t('registration.max_owners_limit'));
                    this.representative.legalOwner = false;
                    this.$forceUpdate();
                    return;
                }

                this.owners.push(
                    {
                        legalOwner: event.target.checked,
                        ownershipPercentage: this.representative.ownershipPercentage,
                        firstName: this.representative.firstName,
                        lastName: this.representative.lastName,
                        citizenship: this.representative.citizenship,
                        countryOfBirth: this.representative.birthCountry,
                        representativeTaxId: this.registrationInfo.taxNumber,
                        birthDate: this.representative.birthDate,
                        address: this.representative.address,
                        zip: this.representative.zip,
                        city: this.representative.city,
                        addressTemporary: this.representative.temporaryAddress,
                        pio: this.representative.pio,
                        disabled: true
                    }
                )

                this.representative.legalOwner = event.target.checked;

                this.legalOwnerIndex = this.owners.length - 1;
            } else {
                this.removeAdditionalOwner(this.legalOwnerIndex)
                this.legalOwnerIndex = null;
            }
        },
        showAlert(text) {
            swal.fire({
                title: text,
                confirmButtonText: 'OK',
                buttonsStyling: true
            })
        }
    },
    mounted() {
        this.removeAllOwners();
    }
}
</script>

<style scoped>

</style>